// extracted by mini-css-extract-plugin
export default {"container":"Footer__container___uLgnu","btnCon":"Footer__btnCon___XF4gJ","cancelButton":"Footer__cancelButton___jNGGT"};